<template>
  <div
    class="formfield"
    :class="{
      'formfield--has-helptext': helpText,
    }"
  >
    <InputLabel
      v-if="showLabel"
      class="formfield__label"
      :required="required"
      :label="label"
    />
    <span class="formfield__body">
      <!-- Put an Input in this slot. -->
      <slot></slot>
    </span>
    <InputHelpText
      class="formfield__help_text"
      :helpText="helpText"
      v-if="helpText"
    />
  </div>
</template>

<script>
import BaseComponent from "../BaseComponent";
import InputLabel from "../atoms/Inputs/InputLabel.vue";
import InputHelpText from "../atoms/Inputs/InputHelpText.vue";
import FormMixin from "../mixins/FormMixin";

/**
 * A formfield consists of an InputLabel, an Input and an InputHelpText
 * When used in a form an input should almost always be wrapped in one of these
 * you can wrap an input in this by using the Vue slot.
 */
export default {
  name: "Formfield",
  mixins: [BaseComponent, FormMixin],
  components: {
    InputLabel,
    InputHelpText,
  },
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    // The question that's asked.
    label: {
      type: String,
    },
    // Hint text for the user to understand the question better.
    helpText: {
      type: String,
    },
  },
  computed: {
    showLabel() {
      const { label } = this;
      return label && label.length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../style_variables/style_variables.scss";
.formfield {
  width: 100%;
  max-width: 650px;
  display: grid;
  grid-gap: 12px;
  grid-template-columns: 100%;
  grid-template-rows: auto;
  grid-template-areas:
    "label"
    "body";

  &.formfield--has-helptext {
    grid-template-areas:
      "label"
      "body"
      "help_text";
  }
  .formfield__label {
    grid-area: label;
  }
  .formfield__help_text {
    grid-area: help_text;
  }
  .formfield__body {
    grid-area: body;
  }
  .formfield__rating-and-scale {
    width: 100%;
    max-width: 376px;
    grid-area: rating_input;
    justify-self: start;
  }
  .formfield__scale {
    display: flex;
    width: 100%;
    justify-content: space-between;
    color: $grey_french;
    margin-top: 4px;
  }
}
</style>
